module.exports = __webpack_public_path__ + "static/media/trainingPlan.00f3d4af.svg";